// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #212121;
  color: #ffffff;
  width: 100%;
  max-width: calc(100 * var(--vw));
  padding: calc(5 * var(--vw)) calc(2.5 * var(--vw));
  font-family: "Satoshi", sans-serif;
  overflow-x: hidden;
  box-sizing: border-box;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

/* Top Section */
.footer-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(5 * var(--vw));
  padding-bottom: calc(4 * var(--vw));
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: calc(3 * var(--vw));
}

/* Newsletter Section */
.footer-newsletter {
  display: flex;
  flex-direction: column;
  gap: calc(2 * var(--vw));
}

.newsletter-heading {
  font: 500 normal calc(4 * var(--vw))/1.2 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  color: #ffffff;
  margin: 0;
  margin-bottom: calc(1 * var(--vw));
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  gap: calc(1.5 * var(--vw));
}

.newsletter-input-group {
  display: flex;
  align-items: flex-end;
  gap: calc(2 * var(--vw));
  flex-wrap: wrap;
}

.newsletter-label {
  font: 500 normal calc(1.5 * var(--vw))/1.4 "Satoshi", sans-serif;
  color: #ffffff;
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding-bottom: calc(0.5 * var(--vw));
  min-width: 120px;
}

.newsletter-input {
  flex: 0.5 1;
  min-width: 200px;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  font: 500 normal calc(1.5 * var(--vw))/1.4 "Satoshi", sans-serif;
  padding: calc(0.5 * var(--vw)) 0;
  outline: none;
  transition: border-color 0.3s ease;
}

.newsletter-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.newsletter-input:focus {
  border-bottom-color: #CCFF00;
}

/* Remove autofill background */
.newsletter-input:-webkit-autofill,
.newsletter-input:-webkit-autofill:hover,
.newsletter-input:-webkit-autofill:focus,
.newsletter-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;
  -webkit-text-fill-color: #ffffff !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Remove autofill background for Firefox */
.newsletter-input:-moz-autofill {
  background-color: #121212 !important;
  color: #ffffff !important;
}

.newsletter-submit {
  display: flex;
  align-items: center;
  gap: calc(0.5 * var(--vw));
  background: transparent;
  border: none;
  color: #ffffff;
  font: 500 normal calc(1.2 * var(--vw))/1.4 "Satoshi", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  padding: calc(0.5 * var(--vw)) 0;
  transition: border-color 0.3s ease, opacity 0.3s ease;
  white-space: nowrap;
}

.newsletter-submit:hover:not(:disabled) {
  opacity: 1;
  border-bottom-color: #CCFF00;
  color: #CCFF00;
}

.newsletter-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-arrow {
  font-size: calc(1.2 * var(--vw));
  line-height: 1;
}

.newsletter-description {
  font: 400 normal calc(1.2 * var(--vw))/1.6 "Satoshi", sans-serif;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  max-width: 500px;
}

.newsletter-message {
  font: 400 normal calc(1.2 * var(--vw))/1.6 "Satoshi", sans-serif;
  margin: 0;
}

.newsletter-message.success {
  color: #CCFF00;
}

.newsletter-message.error {
  color: #ff6b6b;
}

/* Navigation Links */
.footer-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: calc(3 * var(--vw));
  justify-content: end;
}

.nav-column {
  display: flex;
  flex-direction: column;
  gap: calc(1.5 * var(--vw));
}

.nav-heading {
  font: 500 normal calc(1.2 * var(--vw))/1.4 "Satoshi", sans-serif;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.nav-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: calc(1 * var(--vw));
}

.nav-links li {
  margin: 0;
}

.nav-links a {
  color: #ffffff;
  text-decoration: none;
  font: 500 normal calc(1.2 * var(--vw))/1.4 "Satoshi", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  transition: opacity 0.3s ease;
  display: inline-block;
}

.nav-links a:hover {
  opacity: 0.7;
}

/* Bottom Section */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: calc(2 * var(--vw));
}

.footer-copyright {
  font: 400 normal calc(1 * var(--vw))/1.4 "Satoshi", sans-serif;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.footer-copyright p {
  margin: 0;
}

.copyright-separator {
  margin: 0 calc(0.8 * var(--vw));
  opacity: 0.6;
}

.footer-legal-link {
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.footer-legal-link:hover {
  opacity: 0.7;
}

.footer-logo {
  font: 700 normal calc(3 * var(--vw))/1.2 "Satoshi", sans-serif;
  color: #ffffff;
  letter-spacing: -0.02em;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.footer-logo p {
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: calc(4 * var(--vw));
  }

  .footer-nav {
    grid-template-columns: repeat(3, 1fr);
    gap: calc(4 * var(--vw));
  }

  .newsletter-heading {
    font-size: calc(5 * var(--vw));
  }

  .newsletter-label,
  .newsletter-input {
    font-size: calc(2 * var(--vw));
  }

  .newsletter-submit {
    font-size: calc(1.8 * var(--vw));
  }

  .submit-arrow {
    font-size: calc(1.8 * var(--vw));
  }

  .newsletter-description {
    font-size: calc(1.8 * var(--vw));
  }

  .nav-heading,
  .nav-links a {
    font-size: calc(1.8 * var(--vw));
  }

  .footer-copyright {
    font-size: calc(1.5 * var(--vw));
  }

  .footer-logo {
    font-size: calc(4 * var(--vw));
  }
}

@media (max-width: 768px) {
  .footer {
    padding: calc(8 * var(--vw)) calc(5 * var(--vw));
  }

  .footer-top {
    gap: calc(6 * var(--vw));
    padding-bottom: calc(6 * var(--vw));
    margin-bottom: calc(5 * var(--vw));
  }

  .newsletter-heading {
    font-size: calc(7 * var(--vw));
  }

  .newsletter-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: calc(3 * var(--vw));
  }

  .newsletter-label {
    font-size: calc(3.5 * var(--vw));
    border-bottom: none;
    padding-bottom: 0;
  }

  .newsletter-input {
    font-size: calc(3.5 * var(--vw));
    min-width: 100%;
  }

  .newsletter-submit {
    font-size: calc(3 * var(--vw));
    justify-content: flex-start;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .submit-arrow {
    font-size: calc(3 * var(--vw));
  }

  .newsletter-description {
    font-size: calc(2.5 * var(--vw));
  }

  .newsletter-message {
    font-size: calc(2.5 * var(--vw));
  }

  .footer-nav {
    grid-template-columns: 1fr;
    gap: calc(5 * var(--vw));
  }

  .nav-heading {
    font-size: calc(3 * var(--vw));
  }

  .nav-links a {
    font-size: calc(3 * var(--vw));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: calc(4 * var(--vw));
  }

  .footer-copyright {
    font-size: calc(2.5 * var(--vw));
  }

  .footer-logo {
    font-size: calc(6 * var(--vw));
    text-align: left;
  }

  .footer-logo .true-focus-container {
    transform: translateZ(0);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);
  }

  .footer-logo .true-focus-word {
    font-size: calc(12 * var(--vw)) !important;
    transform: translateZ(0);
    will-change: filter;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    isolation: isolate;
  }

  /* Reduce blur amount on mobile to prevent ghosting */
  .footer-logo .true-focus-word:not(.active) {
    filter: blur(3px) !important;
    transition: filter 0.3s ease !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/component/footer/footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,kDAAkD;EAClD,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,iDAAiD;EACjD,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iDAAiD;EACjD,cAAc;EACd,gEAAgE;EAChE,gCAAgC;EAChC,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gEAAgE;EAChE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gCAAgC;EAChC,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gEAAgE;EAChE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;EAC9D,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,qCAAqC;IACrC,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,wBAAwB;IACxB,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,iDAAiD;EACnD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA;IACE,0CAA0C;IAC1C,wBAAwB;IACxB,mBAAmB;IACnB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA,qDAAqD;EACrD;IACE,4BAA4B;IAC5B,uCAAuC;EACzC;AACF","sourcesContent":[".footer {\n  background: #212121;\n  color: #ffffff;\n  width: 100%;\n  max-width: calc(100 * var(--vw));\n  padding: calc(5 * var(--vw)) calc(2.5 * var(--vw));\n  font-family: \"Satoshi\", sans-serif;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.footer-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Top Section */\n.footer-top {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: calc(5 * var(--vw));\n  padding-bottom: calc(4 * var(--vw));\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: calc(3 * var(--vw));\n}\n\n/* Newsletter Section */\n.footer-newsletter {\n  display: flex;\n  flex-direction: column;\n  gap: calc(2 * var(--vw));\n}\n\n.newsletter-heading {\n  font: 500 normal calc(4 * var(--vw))/1.2 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  color: #ffffff;\n  margin: 0;\n  margin-bottom: calc(1 * var(--vw));\n}\n\n.newsletter-form {\n  display: flex;\n  flex-direction: column;\n  gap: calc(1.5 * var(--vw));\n}\n\n.newsletter-input-group {\n  display: flex;\n  align-items: flex-end;\n  gap: calc(2 * var(--vw));\n  flex-wrap: wrap;\n}\n\n.newsletter-label {\n  font: 500 normal calc(1.5 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  color: #ffffff;\n  white-space: nowrap;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  padding-bottom: calc(0.5 * var(--vw));\n  min-width: 120px;\n}\n\n.newsletter-input {\n  flex: 0.5;\n  min-width: 200px;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  color: #ffffff;\n  font: 500 normal calc(1.5 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  padding: calc(0.5 * var(--vw)) 0;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.newsletter-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.newsletter-input:focus {\n  border-bottom-color: #CCFF00;\n}\n\n/* Remove autofill background */\n.newsletter-input:-webkit-autofill,\n.newsletter-input:-webkit-autofill:hover,\n.newsletter-input:-webkit-autofill:focus,\n.newsletter-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #121212 inset !important;\n  -webkit-text-fill-color: #ffffff !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Remove autofill background for Firefox */\n.newsletter-input:-moz-autofill {\n  background-color: #121212 !important;\n  color: #ffffff !important;\n}\n\n.newsletter-submit {\n  display: flex;\n  align-items: center;\n  gap: calc(0.5 * var(--vw));\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font: 500 normal calc(1.2 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  padding: calc(0.5 * var(--vw)) 0;\n  transition: border-color 0.3s ease, opacity 0.3s ease;\n  white-space: nowrap;\n}\n\n.newsletter-submit:hover:not(:disabled) {\n  opacity: 1;\n  border-bottom-color: #CCFF00;\n  color: #CCFF00;\n}\n\n.newsletter-submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.submit-arrow {\n  font-size: calc(1.2 * var(--vw));\n  line-height: 1;\n}\n\n.newsletter-description {\n  font: 400 normal calc(1.2 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n  max-width: 500px;\n}\n\n.newsletter-message {\n  font: 400 normal calc(1.2 * var(--vw))/1.6 \"Satoshi\", sans-serif;\n  margin: 0;\n}\n\n.newsletter-message.success {\n  color: #CCFF00;\n}\n\n.newsletter-message.error {\n  color: #ff6b6b;\n}\n\n/* Navigation Links */\n.footer-nav {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: calc(3 * var(--vw));\n  justify-content: end;\n}\n\n.nav-column {\n  display: flex;\n  flex-direction: column;\n  gap: calc(1.5 * var(--vw));\n}\n\n.nav-heading {\n  font: 500 normal calc(1.2 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n.nav-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: calc(1 * var(--vw));\n}\n\n.nav-links li {\n  margin: 0;\n}\n\n.nav-links a {\n  color: #ffffff;\n  text-decoration: none;\n  font: 500 normal calc(1.2 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  transition: opacity 0.3s ease;\n  display: inline-block;\n}\n\n.nav-links a:hover {\n  opacity: 0.7;\n}\n\n/* Bottom Section */\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: calc(2 * var(--vw));\n}\n\n.footer-copyright {\n  font: 400 normal calc(1 * var(--vw))/1.4 \"Satoshi\", sans-serif;\n  color: #ffffff;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.footer-copyright p {\n  margin: 0;\n}\n\n.copyright-separator {\n  margin: 0 calc(0.8 * var(--vw));\n  opacity: 0.6;\n}\n\n.footer-legal-link {\n  color: #ffffff;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.footer-legal-link:hover {\n  opacity: 0.7;\n}\n\n.footer-logo {\n  font: 700 normal calc(3 * var(--vw))/1.2 \"Satoshi\", sans-serif;\n  color: #ffffff;\n  letter-spacing: -0.02em;\n  text-align: right;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.footer-logo p {\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .footer-top {\n    grid-template-columns: 1fr;\n    gap: calc(4 * var(--vw));\n  }\n\n  .footer-nav {\n    grid-template-columns: repeat(3, 1fr);\n    gap: calc(4 * var(--vw));\n  }\n\n  .newsletter-heading {\n    font-size: calc(5 * var(--vw));\n  }\n\n  .newsletter-label,\n  .newsletter-input {\n    font-size: calc(2 * var(--vw));\n  }\n\n  .newsletter-submit {\n    font-size: calc(1.8 * var(--vw));\n  }\n\n  .submit-arrow {\n    font-size: calc(1.8 * var(--vw));\n  }\n\n  .newsletter-description {\n    font-size: calc(1.8 * var(--vw));\n  }\n\n  .nav-heading,\n  .nav-links a {\n    font-size: calc(1.8 * var(--vw));\n  }\n\n  .footer-copyright {\n    font-size: calc(1.5 * var(--vw));\n  }\n\n  .footer-logo {\n    font-size: calc(4 * var(--vw));\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: calc(8 * var(--vw)) calc(5 * var(--vw));\n  }\n\n  .footer-top {\n    gap: calc(6 * var(--vw));\n    padding-bottom: calc(6 * var(--vw));\n    margin-bottom: calc(5 * var(--vw));\n  }\n\n  .newsletter-heading {\n    font-size: calc(7 * var(--vw));\n  }\n\n  .newsletter-input-group {\n    flex-direction: column;\n    align-items: stretch;\n    gap: calc(3 * var(--vw));\n  }\n\n  .newsletter-label {\n    font-size: calc(3.5 * var(--vw));\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .newsletter-input {\n    font-size: calc(3.5 * var(--vw));\n    min-width: 100%;\n  }\n\n  .newsletter-submit {\n    font-size: calc(3 * var(--vw));\n    justify-content: flex-start;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  }\n\n  .submit-arrow {\n    font-size: calc(3 * var(--vw));\n  }\n\n  .newsletter-description {\n    font-size: calc(2.5 * var(--vw));\n  }\n\n  .newsletter-message {\n    font-size: calc(2.5 * var(--vw));\n  }\n\n  .footer-nav {\n    grid-template-columns: 1fr;\n    gap: calc(5 * var(--vw));\n  }\n\n  .nav-heading {\n    font-size: calc(3 * var(--vw));\n  }\n\n  .nav-links a {\n    font-size: calc(3 * var(--vw));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: calc(4 * var(--vw));\n  }\n\n  .footer-copyright {\n    font-size: calc(2.5 * var(--vw));\n  }\n\n  .footer-logo {\n    font-size: calc(6 * var(--vw));\n    text-align: left;\n  }\n\n  .footer-logo .true-focus-container {\n    transform: translateZ(0);\n    will-change: transform;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform: translateZ(0);\n  }\n\n  .footer-logo .true-focus-word {\n    font-size: calc(12 * var(--vw)) !important;\n    transform: translateZ(0);\n    will-change: filter;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform: translateZ(0);\n    isolation: isolate;\n  }\n\n  /* Reduce blur amount on mobile to prevent ghosting */\n  .footer-logo .true-focus-word:not(.active) {\n    filter: blur(3px) !important;\n    transition: filter 0.3s ease !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
